import { RootState } from "store/index";
import { createSelector } from "@reduxjs/toolkit";
// eslint-disable-next-line max-len
import { InvoiceUpdateSupplierInfoSummaryBoxProps } from "components/food/ui/supplierInfo/invoiceUpdateSupplier/InvoiceUpdateSupplierInfoSummaryBox";
import { SupplierInfoActionStatus } from "models/food/supplierInfo/actionStatus";

const invoiceUpdateSupplierInfoActionItems = (state: RootState) =>
  state.invoiceUpdateSupplierInfo.actionItems;

const invoiceUpdateSupplierInfoResolvedInvoices = (state: RootState) =>
  state.invoiceUpdateSupplierInfo.resolvedInvoices;

const summary = createSelector(
  [
    invoiceUpdateSupplierInfoResolvedInvoices,
    invoiceUpdateSupplierInfoActionItems,
  ],
  (solvedInvoices, toSolvedItems): InvoiceUpdateSupplierInfoSummaryBoxProps => {
    const matched = Object.entries(solvedInvoices).length; // invoice items have been updated.
    const toSolvedItemsArray = Object.entries(toSolvedItems);
    const relinked = toSolvedItemsArray.filter(
      ([, invoiceItem]) =>
        invoiceItem.state.chooseAction === SupplierInfoActionStatus.RELINKED,
    ).length; // invoice items have been relinked.
    const createdNew = toSolvedItemsArray.filter(
      ([, invoiceItem]) =>
        invoiceItem.state.chooseAction === SupplierInfoActionStatus.CREATED,
    ).length; // invoice items used to create new food.
    const allToSolvedCount = toSolvedItemsArray.length; // all invoice items need to be solved.
    return {
      updated: matched,
      skipped: allToSolvedCount - createdNew - relinked,
      relinked,
      created: createdNew,
    };
  },
);

const invoiceUpdateSupplierInfoIsLoading = (state: RootState) =>
  state.invoiceUpdateSupplierInfo.isLoading;

const invoiceUpdateSupplierInfoError = (state: RootState) =>
  state.invoiceUpdateSupplierInfo.error;

export default {
  invoiceUpdateSupplierInfoActionItems,
  invoiceUpdateSupplierInfoResolvedInvoices,
  summary,
  invoiceUpdateSupplierInfoIsLoading,
  invoiceUpdateSupplierInfoError,
};
